module.exports = __webpack_public_path__ + "static/img/introduce_serve.09ba67be.png";